/* ============================================================
   assets/senchado-ttj-sticky.js
   TTJ（TOKYO TEA JOURNAL）申込LPのスティッキー申込バー制御。
   移植元: 現行 snippets/_ttj-floating.liquid の type_center 版
           （LP下部固定・中央1ボタン「お茶の定期便を試してみる」）。

   振る舞い:
     - 申込口（[data-ttj-apply]）が視界内にある間はバーを隠す（data-ttj-hidden を付与）。
       スクロールで外れたら表示する。
     - 申込口は複数ある（P0 ① 申込ボックス／FAQ後の最終CTA）。**どれか1つでも交差中なら
       隠す**。1要素だけを見ていると、最終CTAの上にバーが重なって同じCTAが二重に出る。
     - バーの既定（属性なし）は CSS 側で「常時表示」。したがって JS 無効／
       IntersectionObserver 非対応の環境では常時表示にフォールバックする。
     - 初期チラつき防止のため、監視開始前に現在の交差状態を同期反映する。
     - 複数セクションが同一ページに載っても安全なよう、バーと同じ
       [data-section-id] スコープ内の申込口だけを対象にする。
   ============================================================ */
(function () {
  function init() {
    var bars = document.querySelectorAll('[data-ttj-sticky]');
    if (!bars.length || !('IntersectionObserver' in window)) return;

    Array.prototype.forEach.call(bars, function (bar) {
      var scope = bar.closest('[data-section-id]') || document;
      var targets = scope.querySelectorAll('[data-ttj-apply]');
      if (!targets.length) return;

      // 交差中の申込口の集合（Set 非依存＝配列で保持し ES5 互換を保つ）。
      var visible = [];

      function sync() {
        if (visible.length) {
          bar.setAttribute('data-ttj-hidden', '');
        } else {
          bar.removeAttribute('data-ttj-hidden');
        }
      }

      function mark(el, isVisible) {
        var i = visible.indexOf(el);
        if (isVisible && i === -1) visible.push(el);
        if (!isVisible && i !== -1) visible.splice(i, 1);
      }

      // 初期状態を同期反映（監視開始前）: いずれかの申込口が視界内なら即座に隠す。
      var vh = window.innerHeight || document.documentElement.clientHeight;
      Array.prototype.forEach.call(targets, function (el) {
        var rect = el.getBoundingClientRect();
        mark(el, rect.bottom > 0 && rect.top < vh);
      });
      sync();

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          mark(entry.target, entry.isIntersecting);
        });
        sync();
      }, { threshold: 0 });

      Array.prototype.forEach.call(targets, function (el) {
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
